<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.esfl_cd_codigo }} - {{ $t('descricao') }} :
								{{ item.esfl_ds_descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						style="border-radius: 5px !important; min-width: 65px"
						:loading="exportando"
						@click="downloadCSVEstratoFlorestal()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotalPagination.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<div
			v-show="!showForm"
			v-if="mostrarMapaPlantio == true"
			class="BackArrow"
		>
			<Button
				style="padding-right: 17px !important"
				icon="fas fa-solid fa-arrow-left"
				outlined
				@click="changeFormAndCloseAllActions"
			/>
		</div>

		<CrudForm
			:is-visible="showForm"
			:backdrop="!mostrarMapaPlantio"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
		>
			<template #actions>
				<div class="w-full flex justify-center py-4">
					<BreadCrumb
						v-model="step"
						:crumbs="[
							{ name: `${isEdit ? $t('edition') : $t('registry')}`, step: 0 },
							{ name: $t('planning'), step: 1 },
						]"
					/>
				</div>

				<!-- <Steps>
        <Step :title="`${isEdit ? $t('edition') : $t('registry')}`"
          :description="`${isEdit ? $t('changeTheData') : $t('mainData')}`" :completed="isEdit || mostrarMapaPlantio"
          :active="!mostrarMapaPlantio" />
        <Step :title="$t('planning')" :description="$t('planningTime')" :completed="!isGeoJsonPlantioEmpty"
          :disabled="!mostrarMapaPlantio" :active="mostrarMapaPlantio" />
      </Steps> -->
			</template>
			<template #form>
				<div
					v-show="!mostrarMapaPlantio"
					class="registry"
				>
					<InputText
						v-model="model.esfl_ds_descricao"
						style="margin-top: 1rem"
						:label="$t('description') + '*'"
					/>

					<RadioButtons
						v-model="model.esfl_is_traditional"
						style="margin-top: 1rem"
						group-name="valida-dap"
						:label="$t('tipoDoEstrato') + '*'"
						:options="[
							{ label: $t('continuous'), value: false },
							{ label: `${$t('temporary')} (${$t('spot')})`, value: true },
						]"
					/>
					<div style="display: flex; justify-content: end; padding: 1rem 0">
						<!-- <Switcher v-model="model.esfl_is_traditional" :label="`${$t('temporary')} (${$t('spot')})`"
            :left-label="$t('continuous')" /> -->

						<p
							v-if="isEdit && mostrarOpcaoDePlanejarEstrato"
							class="go__to__plan__text"
							@click="mostrarMapaPlantio = true"
						>
							{{ `${$t('goPlan')} ➝` }}
						</p>
					</div>
					<div
						style="padding: 0"
						class="container__crud__crudform__buttons"
					>
						<Button
							:label="$t('cancel')"
							color="trv-secondary"
							semantic-class="mini"
							outlined
							@click="changeFormAndCloseAllActions"
						/>
						<Button
							:label="isEdit ? $t('save') : $t('plan')"
							color="trv-default"
							semantic-class="mini"
							:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
							@click="saveClick()"
						/>
					</div>
				</div>
				<div
					v-show="mostrarMapaPlantio"
					class="planejamento"
				>
					<div
						style="
							margin: 1rem 0;
							border-radius: 5px;
							display: flex;
							background-color: var(--color-background);
							padding: 1rem;
							flex-direction: row;
							justify-content: space-between;
						"
					>
						<div style="display: flex; flex-direction: row; gap: 1rem">
							<i
								style="vertical-align: sub; font-size: 1.6rem"
								class="fas fa-tree"
							/>
							<div>
								<p style="height: fit-content; padding: 0; font-size: 1.1rem; margin: 0">
									{{ model.esfl_ds_descricao }}
								</p>
								<p style="height: fit-content; padding: 0; font-size: 0.7rem; margin: 0">
									{{ model.fazenda || $t('pickFarm') }}
									<span
										v-if="!isEdit && model.fazenda"
										style="text-decoration: underline; cursor: pointer"
										@click="
											resetState()
											model.fazenda = ''
										"
										>{{ $t('pickAnotherFarm') }}</span
									>
								</p>
							</div>
						</div>
						<KebabMenu
							v-model="intentionEstrato"
							style="right: 2rem; padding: 0.8rem"
							:options="kebabOptionsEstrato"
						/>
					</div>
					<div v-show="!Object.entries(getGeoJsonPtio).length">
						<DropdownFk
							v-model="model.fk_fzda_fazenda"
							:label="$t('selectFarm')"
							:dropdown-options="fazendas"
							:has-blocked-items="!model.esfl_is_traditional"
							block-propertie="FazendaComPlantiosDisponiveis"
							block-reason="Esta fazenda não possui plantios disponíveis para estratos tradicionais"
							@input="idFazenda"
						/>
						<p
							v-if="buscandoFazenda"
							style="
								width: 100%;
								margin: 1rem 0 0 0;
								display: flex;
								flex-direction: row;
								gap: 0.5rem;
								padding: 0.5rem 0.5rem;
								margin-top: 0.3rem;
								background: var(--color-success-message);
								color: var(--color-success-background);
								font-weight: 600;
								border-radius: 5px;
							"
						>
							<Loading />
							{{ $t('fetchingFarmData') }}
						</p>
					</div>
					<div v-show="Object.entries(getGeoJsonPtio).length">
						<div class="flex justify-end py-2">
							<a
								class="hover:underline"
								@click="resetFiltros"
								>{{ $t('clearFilters') }}</a
							>
						</div>
						<div style="display: flex; justify-content: space-around">
							<p
								class="tab__item"
								:class="{ active__item: tabs === 0 }"
								@click="tabs = 0"
							>
								<strong> {{ $t('plantation') }} </strong>
							</p>
							<p
								class="tab__item"
								:class="{ active__item: tabs === 1 }"
								@click="tabs = 1"
							>
								<strong> {{ $t('section') }}</strong>
							</p>
						</div>
						<div v-show="tabs === 0">
							<div style="display: flex; justify-content: space-around; width: 100%">
								<p
									class="tab__item"
									:class="{ active__item: tabs2 === 0 }"
									@click="tabs2 = 0"
								>
									<strong> {{ $t('filters') }} </strong>
								</p>
								<p
									class="tab__item"
									:class="{ active__item: tabs2 === 1 }"
									@click="tabs2 = 1"
								>
									<strong> {{ $t('variables') }}</strong>
								</p>
							</div>
							<div
								v-show="tabs2 === 0"
								style="display: flex; flex-direction: column; gap: 0.5rem"
							>
								<div style="display: flex; flex-direction: row; gap: 0.5rem">
									<MultiSelect
										v-model="filtroConfig.selectedCodigosPlantios"
										:label="$t('plantationCode')"
										:options="codPlantio"
									/>
									<Button
										mini
										icon="fas fa-paste"
										style="width: auto; height: auto; margin-top: auto; margin-left: 2%"
										@click="copiaEcola = !copiaEcola"
									/>
								</div>
								<InputText
									v-show="copiaEcola"
									style="margin-top: 10px"
									:placeholder="$t('helpSelectionPlantationCopyPaste')"
									:label="$t('selectionByCopyPaste')"
									@blur="selecionaPorCodigo"
								/>
								<MultiSelect
									v-model="filtroConfig.selectedEspacamentos"
									:label="$t('plantationSpacing')"
									:options="espacamentoPlantio"
								/>
								<MultiSelect
									v-model="filtroConfig.selectedMaterialGenetico"
									:label="$t('geneticMaterial')"
									:options="materialPlantio"
								/>
								<MultiSelect
									v-model="filtroConfig.selectedAreaPlantio"
									:label="$t('effectiveArea')"
									:options="areaPlantio"
								/>
								<!-- <MultiSelect
                      label="Idade Plantio"
                      :options="idadePlantio"
                      v-model="filtroConfig.selectedDataPlantio"
                    /> -->
								<MultiSelect
									v-model="filtroConfig.selectedDataPlantio"
									:label="$t('plantationDate')"
									:options="dataPlantio"
								/>
								<p
									v-show="filtros.areaEfetivaPlantioMaxMin"
									style="text-align: center; margin: 10px 0px 0px 0px !important"
								>
									{{ $t('effectiveAreaInterval') }}
								</p>
								<div style="margin: 0px 20px">
									<v-range-slider
										v-show="filtros.areaEfetivaPlantioMaxMin"
										:max="maxArea"
										:min="minArea"
										:color="rootStyle['--color-green']"
										:track-color="rootStyle['--color-success-background']"
										thumb-label
										step="0.01"
										@input="handleChangeArea($event)"
									/>
								</div>
								<p
									v-show="filtros.dataPlantioMaxMin"
									style="text-align: center; margin: 0px !important"
								>
									{{ $t('plantationDateInterval') }}
								</p>
								<div style="margin: 0px 20px">
									<v-range-slider
										v-show="filtros.dataPlantioMaxMin"
										:max="maxTimestamp"
										:step="47304000000"
										:min="minTimestamp"
										:color="rootStyle['--color-green']"
										:track-color="rootStyle['--color-success-background']"
										@input="handleChangeData($event)"
									>
										<template #thumb-label="{ value }">
											{{ new Date(value).toLocaleDateString() }}
										</template>
									</v-range-slider>
								</div>
							</div>
							<div
								v-show="tabs2 === 1"
								style="display: flex; flex-direction: column; gap: 0.5rem"
							>
								<Card
									v-for="ct in filtros.customVariablesPlantio"
									:key="ct.name + ct.value"
									style="
										padding: 5px;
										margin: 10px;
										box-shadow:
											rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
											rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
									"
								>
									<p style="margin: 8px; font-weight: bold">
										{{ ct.name }}
									</p>
									<div style="display: flex; flex-wrap: wrap">
										<Tag
											v-for="custom in ct.values"
											:key="custom"
											style="margin: 5px; cursor: pointer"
											:class-name="`default ${filtroConfig.customsPlantio.indexOf(custom) > -1 ? '' : 'outlined'} ${ct.blocked ? 'tag-disabled' : ''}`"
											:label="custom"
											:disabled="ct.blocked"
											@click="ct.blocked ? null : manejaCustomsPlantio($event)"
										/>
									</div>
								</Card>
							</div>
						</div>
						<div v-show="tabs === 1">
							<div style="display: flex; justify-content: space-around; width: 100%">
								<p
									class="tab__item"
									:class="{ active__item: tabs3 === 0 }"
									@click="tabs3 = 0"
								>
									<strong> {{ $t('filters') }} </strong>
								</p>
								<p
									class="tab__item"
									:class="{ active__item: tabs3 === 1 }"
									@click="tabs3 = 1"
								>
									<strong> {{ $t('variables') }}</strong>
								</p>
							</div>
							<div
								v-show="tabs3 === 0"
								style="display: flex; flex-direction: column; gap: 0.5rem"
							>
								<div style="display: flex; flex-direction: row; gap: 0.5rem">
									<MultiSelect
										v-model="filtroConfig.selectedCodigosTalhao"
										:label="$t('sectionCode')"
										:options="codTalhao"
									/>
									<Button
										mini
										icon="fas fa-paste"
										style="width: auto; height: auto; margin-top: auto; margin-left: 2%"
										@click="copiaEcolaTalhao = !copiaEcolaTalhao"
									/>
								</div>
								<InputText
									v-show="copiaEcolaTalhao"
									style="margin-top: 10px"
									:placeholder="$t('helpSelectionSectionCopyPaste')"
									:label="$t('selectionByCopyPaste')"
									@blur="selecionaPorCodigoTalhao"
								/>
								<MultiSelect
									v-model="filtroConfig.selectedAreaTalhao"
									:label="$t('sectionArea')"
									:options="areaTalhao"
								/>
								<p v-show="filtros.areaEfetivaPlantioMaxMin">
									{{ $t('effectiveAreaInterval') }}
								</p>
								<v-range-slider
									v-show="filtros.areaEfetivaTalhaoMaxMin"
									:max="maxAreaTalhao"
									:min="minAreaTalhao"
									:color="rootStyle['--color-green']"
									:track-color="rootStyle['--color-success-background']"
									thumb-label
									step="0.01"
									@input="handleChangeAreaTalhao($event)"
								/>
							</div>

							<div v-show="tabs3 === 1">
								<Card
									v-for="ct in filtros.customVariablesTalhao"
									:key="ct.name + ct.value"
									style="
										padding: 5px;
										margin: 10px;
										box-shadow:
											rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
											rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
									"
								>
									<p style="margin: 8px; font-weight: bold">
										{{ ct.name }}
									</p>
									<div style="display: flex; flex-wrap: wrap">
										<Tag
											v-for="custom in ct.values"
											:key="custom"
											style="margin: 5px; cursor: pointer"
											:class-name="`default ${filtroConfig.customsTalhao.indexOf(custom) > -1 ? '' : 'outlined'} ${ct.blocked ? 'tag-disabled' : ''}`"
											:label="custom"
											:disabled="ct.blocked"
											@click="ct.blocked ? null : manejaCustomsTalhao($event)"
										/>
									</div>
								</Card>
							</div>
						</div>
						<div style="display: flex; justify-content: space-between; margin-top: 10px; gap: 1rem">
							<!-- <div style="display:flex;"> -->
							<Button
								:label="$t('back')"
								color="trv-secondary"
								outlined
								semantic-class="mini"
								@click="changeFormAndCloseAllActionsBack"
							/>
							<Button
								:label="$t('plan')"
								semantic-class="mini"
								:loading="planejandoEstrato"
								:disabled="!preparaPlanejamento.length"
								@click="clickPlanejar"
							/>
							<!-- </div> -->
							<!-- <Button :label="$t('clearFilters')" semanticClass="mini" widthAuto
              :disabled="!Object.values(filtroConfig).some(s => s.length)" @click="resetFiltros" /> -->
						</div>
					</div>
				</div>
			</template>
		</CrudForm>

		<PlantiosEstratoFlorestal
			v-if="mostrarMapaPlantio"
			:show-info-plantio="togglePlantio"
			@plantioClick="handlePlantioClick"
		/>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Loading from '../../../../components/Loading/Loading'
import RadioButtons from '../../../../components/RadioButtons/RadioButtons'
import PlantiosEstratoFlorestal from '../EstratoFlorestal/PlantiosEstratoFlorestal'

import Card from '../../../../components/Card/Card'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import Tag from '../../../../components/Tag/Tag'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import PlanejamentoEstratoFlorestalMixins from '../../../../mixins/PlanejamentoEstratoFlorestalMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'
import GridPagination from '../../../../components/GridPagination/GridPagination.vue'

import {
	createEstratoFlorestal,
	deleteEstratoFlorestalByIdList,
	editaPlanejamentoEstratoFlorestal,
	getAllEstratoFlorestais,
	getMapsByEstratoFlorestalIdToEdit,
	planejaEstratoFlorestal,
	updateEstratoFlorestal,
} from '../../../../services/requests/EstratoFlorestalRequests'

import { getFazendasParaEstratoFlorestalDropdown } from '../../../../services/requests/FazendaRequests'

import download from 'downloadjs'

import { exportarCsv } from '../../../../utils/csvHellpers'

import _ from 'lodash'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	name: 'EstratoFlorestal',
	components: {
		Button,
		CrudForm,
		CrudTable,
		// DownloadButton,
		InputSearch,
		PlantiosEstratoFlorestal,
		// Pagination,
		// Switcher,
		DropdownCheckbox,
		KebabMenu,
		Loading,
		// Steps,
		// Step,
		DropdownFk,
		RadioButtons,
		Card,
		MultiSelect,
		Tag,
		BreadCrumb,
		InputText,
		GridPagination,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 * - PlanejamentoEstratoFlorestalMixins: contém funções que fazem interação com o mapa
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins, PlanejamentoEstratoFlorestalMixins],
	data() {
		return {
			step: 0,
			planejandoEstrato: false,
			intentionEstrato: {},
			togglePlantio: false,
			intention: {},
			headersSelecionados: [
				'esfl_ds_descricao',
				'fazenda',
				'esfl_cd_codigo',
				'esfl_is_traditional',
			],
			mostrarMapaPlantio: false,
			textFilter: '',
			exportando: false,
			showExclusionAlert: false,

			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				esfl_ds_descricao: '',
				fk_fzda_fazenda: '',
				esfl_is_traditional: false,
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				prefix: 'EF',
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'esfl_ds_descricao',
				titleCardPropertie: 'esfl_cd_codigo',
				titleInventoryType: 'esfl_is_traditional',
			},
			tableHeaders: [
				{ key: 'esfl_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'fazenda', value: this.$t('farm'), isActive: true },
				{
					key: 'esfl_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'esfl_is_traditional',
					value: this.$t('stratumType'),
					isActive: true,
				},
			],
			/**
			 * fazendas que serão dispostas no dropdown para atrelar a fazenda
			 */
			fazendas: [],
			/**
			 * Mostrar opcao de planejamento de estrato
			 */
			mostrarOpcaoDePlanejarEstrato: false,
			/**
			 * Variavel que controla se o estrato ja foi ou nao planejado
			 */
			estratoAindaNaoPlanejado: true,
		}
	},

	computed: {
		kebabOptionsEstrato() {
			return [
				{
					value: `toggleInfoPlantio-${this.togglePlantio ? 'off' : 'on'}`,
					label: `${
						this.togglePlantio ? this.$t('hide') : this.$t('show')
					} ${this.$t('plantingInfo')}`,
				},
				{
					value: 'downloadFazenda',
					label: this.$t('downloadFazenda'),
				},
				{
					value: 'downloadTalhao',
					label: this.$t('downloadTalhao'),
				},
				{
					value: 'downloadPlantio',
					label: this.$t('downloadPlantio'),
				},
			]
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})
			this.setInventoryType()
			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.esfl_ds_descricao
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		textFilter(value) {
			const pageNumber = 0
			const pageSize = 0
			this.refreshTabela(pageNumber, pageSize, value)
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
		},

		intentionEstrato(value) {
			const intentionsMapped = {
				downloadFazenda: this.actionDownloadFazenda,
				downloadTalhao: this.actionDownloadTalhao,
				downloadPlantio: this.actionDownloadPlantio,
				['toggleInfoPlantio-off']: () => (this.togglePlantio = !this.togglePlantio),
				['toggleInfoPlantio-on']: () => (this.togglePlantio = !this.togglePlantio),
			}

			if (value.intent) intentionsMapped[value.intent]()
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)

					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.resetState()
		this.quantityPerPage = 10
		this.orderTable = ['esfl_cd_codigo']

		getAllEstratoFlorestais().then((response) => {
			const { result: estratosFlorestais } = response.data
			estratosFlorestais.forEach((estratoFlorestal) =>
				this.formataEstratoFlorestalParaCrud(estratoFlorestal),
			)
			this.modelList = estratosFlorestais
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getFazendasParaEstratoFlorestalDropdown().then((response) => {
			this.fazendas = _.orderBy(response, ['FazendaComPlantiosDisponiveis'])
		})
	},
	methods: {
		clickPlanejar() {
			this.isEdit && !this.estratoAindaNaoPlanejado ? this.editaEstrato() : this.planejaEstrato()
		},
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		handlePlantioClick(plantio) {
			console.log('🚀 ~ file: EstratoFlorestal.vue:630 ~ handlePlantioClick ~ plantio:', plantio)
		},

		recarregaEstratoFlorestal() {
			getAllEstratoFlorestais().then((response) => {
				const { result: estratos } = response.data
				estratos.forEach((estrato) => {
					this.formataEstratoFlorestalParaCrud(estrato)
				})
				this.modelList = estratos
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		handlePopState(event) {
			if (event.type === 'popstate') {
				this.$router.push('/estratoflorestal')
			}
		},

		/**
		 * Baixa CSV com o resultado FILTRADO COMPLETO (nao so a pagina ja
		 * carregada): busca tudo numa chamada antes de gerar o arquivo,
		 * sem mexer no estado da grid.
		 */
		async downloadCSVEstratoFlorestal() {
			if (this.exportando) return
			this.exportando = true
			try {
				const response = await getAllEstratoFlorestais(
					0,
					Math.max(this.modelsToBeShowedAndTotalPagination.total, 100),
					this.textFilter,
				)
				const items = response.data.result || []

				const cabecalhoDoCsvEstratoFlorestal = ['Código', 'Fazenda', 'Descrição', 'Tipo de Estrato']

				const linhas = items.map((item) => [
					item.esfl_cd_codigo,
					item.fazenda,
					item.esfl_ds_descricao,
					item.esfl_is_traditional,
				])

				exportarCsv('export_estrato', cabecalhoDoCsvEstratoFlorestal, linhas)
			} finally {
				this.exportando = false
			}
		},

		actionDownloadFazenda() {
			download(
				JSON.stringify(this.getGeoJsonFzda),
				`GeoJSON ${this.$t('farm')} ${this.model.fazenda} ${new Date()
					.toLocaleDateString()
					.replaceAll('/', '-')}`,
				'application/json',
			)
		},
		actionDownloadTalhao() {
			download(
				JSON.stringify(this.getGeoJsonTlho.geojson),
				`GeoJSON ${this.$t('section')} ${this.model.fazenda} ${new Date()
					.toLocaleDateString()
					.replaceAll('/', '-')}`,
				'application/json',
			)
		},

		actionDownloadPlantio() {
			download(
				JSON.stringify(this.getGeoJsonPtio.geojson),
				`GeoJSON ${this.$t('plantation')} ${this.model.fazenda} ${new Date()
					.toLocaleDateString()
					.replaceAll('/', '-')}`,
				'application/json',
			)
		},
		changeFormAndCloseAllActionsBack() {
			this.showForm = !this.showForm
			this.mostrarMapaPlantio = !this.mostrarMapaPlantio
			this.resetState()
		},
		editaEstrato() {
			this.planejandoEstrato = true
			editaPlanejamentoEstratoFlorestal({
				create: this.getGeoJsonPtio.features
					.filter((f) => f.properties.selected)
					.map(({ properties }) => {
						const { fkFazenda, fkTalhao, idPlantio } = properties

						return {
							fk_esfl_estrato_florestal: this.model.id,
							fk_fzda_fazenda: fkFazenda,
							fk_ptio_plantio: idPlantio,
							fk_tlho_talhao: fkTalhao,
							plaes_is_traditional: true,
						}
					}),
				estratoFlorestalId: this.model.id,
				isTraditional: !this.model.esfl_is_traditional,
				delete: this.getGeoJsonPtio.features
					.filter(
						(f) =>
							!f.properties.selected &&
							f.properties.fkPlanejamentoEstratoFlorestal != null &&
							f.properties.fkPlanejamentoEstratoFlorestal != '00000000-0000-0000-0000-000000000000',
					)
					.map(({ properties }) => {
						const { fkFazenda, fkTalhao, idPlantio, fkPlanejamentoEstratoFlorestal } = properties

						return {
							fk_esfl_estrato_florestal: this.model.id,
							fk_fzda_fazenda: fkFazenda,
							fk_ptio_plantio: idPlantio,
							fk_tlho_talhao: fkTalhao,
							id: fkPlanejamentoEstratoFlorestal,
							plaes_is_traditional: true,
						}
					}),
			}).then((response) => {
				if (response.status === 200) {
					this.step = 0
					this.mostrarMapaPlantio = !this.mostrarMapaPlantio
					this.showForm = false
					this.planejandoEstrato = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageText: this.$t('planejamentoAtualizado'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				}
			})
		},
		planejaEstrato() {
			this.planejandoEstrato = true
			planejaEstratoFlorestal({
				isTraditional: !this.model.esfl_is_traditional,
				create: this.preparaPlanejamento,
			}).then((response) => {
				if (response.status === 200) {
					this.step = 0
					this.showForm = false
					this.mostrarMapaPlantio = !this.mostrarMapaPlantio
					// this.showForm = !this.showForm;
					this.planejandoEstrato = false
					this.isEdit = true

					this.recarregaEstratoFlorestal()

					this.modelList.forEach((estrato) => {
						if (estrato.id === this.model.id) {
							estrato.fazenda = this.model.fazenda
							estrato.fk_fzda_fazenda = this.model.fk_fzda_fazenda
						}
					})

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageText: this.$t('planejamentoAtualizado'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				}
			})
		},

		plantiosEstratoFlorestal() {
			this.step = 1
			this.mostrarMapaPlantio = !this.mostrarMapaPlantio
			// this.showForm = false;
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createEstratoFlorestalToPost() {
			return {
				id: uuidv4(),
				esfl_ds_descricao: this.model.esfl_ds_descricao,
				esfl_is_traditional: !this.model.esfl_is_traditional,
			}
		},

		/**
		 * Formata campos do estrato florestal para exibir na tabela de crud
		 */
		formataEstratoFlorestalParaCrud(estratoFlorestal) {
			estratoFlorestal.isCheckedToDelete = false
		},

		/**
		 * Seta fk de fazenda no model vinda do dropdown
		 */
		setFazenda(value) {
			this.model.fk_fzda_fazenda = value
		},

		setInventoryType() {
			for (let i = 0; i < this.modelsToBeShowedAndTotal.items.length; i++) {
				if (this.modelsToBeShowedAndTotal.items[i].esfl_is_traditional === true) {
					this.modelsToBeShowedAndTotal.items[i].esfl_is_traditional = 'Contínuo'
				} else if (this.modelsToBeShowedAndTotal.items[i].esfl_is_traditional === false) {
					this.modelsToBeShowedAndTotal.items[i].esfl_is_traditional = 'Temporário(Spot)'
				}
			}
		},

		/**
		 * Cria novo Estrato Florestal no banco de dados
		 */
		create() {
			const estratoFlorestal = this.createEstratoFlorestalToPost()

			createEstratoFlorestal(estratoFlorestal).then((response) => {
				const { result: estratoFlorestal, isError } = response.data
				this.disableSaveButton = false

				this.resetState()

				if (!isError) {
					// this.cleanModel();
					this.formataEstratoFlorestalParaCrud(estratoFlorestal)
					this.modelList.unshift(estratoFlorestal)

					// this.showForm = false;
					// this.emptyValue = "";

					this.model.id = estratoFlorestal.id

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})

					this.plantiosEstratoFlorestal()
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Atualiza estrato florestal no banco de dados
		 */
		update() {
			var model = Object.assign({}, this.model)
			model.esfl_is_traditional = !model.esfl_is_traditional
			updateEstratoFlorestal(model).then((response) => {
				const { result: estratoFlorestal, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.formataEstratoFlorestalParaCrud(estratoFlorestal)

					const indexEstratoFlorestal = this.modelList
						.map((estratoModelList) => estratoModelList.id)
						.indexOf(estratoFlorestal.id)
					this.$set(this.modelList, indexEstratoFlorestal, estratoFlorestal)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui estrato florestal no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(estratoFlorestal) =>
						this.modelsIdWithCheckedToDelete.includes(estratoFlorestal.id) &&
						estratoFlorestal.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm(this.$t('confirmaExclusao'))

					if (confirmResult) {
						deleteEstratoFlorestalByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var estratosOrganizados = existeRegistroComDependencia
						.map((estrato) => `• EF-${estrato.esfl_cd_codigo} -  ${estrato.esfl_ds_descricao}`)
						.join('<br/>')
					var message = `<b>${this.$t('dependenciaDePlanejamentoOuProcessamento')}:</b> <br/><br/> ${estratosOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			if (this.model.esfl_is_traditional == 'Contínuo') {
				this.model.esfl_is_traditional = false
			} else if (this.model.esfl_is_traditional == 'Temporário(Spot)') {
				this.model.esfl_is_traditional = true
			}

			this.titleForm = `${this.$t('edit')} ${this.$t('forestStratification')}`
			this.isEdit = true
			this.togglePlantio = true
			this.changeFormAndCloseAllActions()

			this.mostrarOpcaoDePlanejarEstrato = false

			getMapsByEstratoFlorestalIdToEdit(this.model.id).then(({ data }) => {
				this.resetState()

				this.mostrarOpcaoDePlanejarEstrato = true

				if (data.result.filtros && data.result.maps) {
					const { fazenda, talhoes, plantios } = data.result.maps[0]
					this.filtros = data.result.filtros

					this.setAllShapes({
						fazenda: JSON.parse(fazenda),
						talhoes: JSON.parse(talhoes),
						plantios: JSON.parse(plantios),
					})
					this.estratoAindaNaoPlanejado = false
				} else {
					this.estratoAindaNaoPlanejado = true
				}
			})
		},

		refreshTabela(pageNumber, pageSize, filteringWord) {
			getAllEstratoFlorestais(pageNumber, pageSize, filteringWord).then((response) => {
				const { result: estratosFlorestais } = response.data
				if (!estratosFlorestais || estratosFlorestais.length === 0) {
					return
				}
				estratosFlorestais.forEach((estratoFlorestal) =>
					this.formataEstratoFlorestalParaCrud(estratoFlorestal),
				)
				this.modelList = estratosFlorestais
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('forestStratification')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			// this.resetState();
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>

<style scoped>
.BackArrow {
	width: 2.5rem;
	height: 3rem;
	position: fixed;
	top: 5rem;
	right: 0%;
	z-index: 10;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.tag-disabled {
	pointer-events: none;
	opacity: 0.5;
	cursor: not-allowed;
}

.container__loading {
	width: auto;
}

.go__to__plan__text {
	margin: 0;
	text-align: end;
	font-size: 0.8rem;
	cursor: pointer;
}

.go__to__plan__text:hover {
	color: var(--color-green);
}

.tab__item {
	margin: 0;
	width: 50%;
	text-align: center;
	cursor: pointer;
}

.tab__item:hover {
	background: var(--color-success-message);
}

.tab__item strong {
	line-height: 3;
	gap: 0.5rem;
	display: flex;
	align-items: center;
	flex-direction: row;
	justify-content: center;
}

.active__item::after {
	content: '';
	background: var(--color-green);
	display: block;
	height: 2px;
}
</style>

<style>
.v-slider__track-background {
	left: unset !important;
	width: 100% !important;
}

.tag-disabled {
	pointer-events: none;
	opacity: 0.5;
	cursor: not-allowed;
}
</style>
